import React from "react";
import { connect } from "react-redux";
import history from "../../auth/history";
import './SenderDetails.css';
import './SendersList.css';
import './SenderPhotoUpload.css';
import moment from "moment";
import Avatar from 'react-avatar';
import { store } from "../../redux/store";

class SenderSubDetails extends React.Component{
    constructor(props){
        super(props);
        this.state={
			phoneNo: this.props.phone,
			password:'',
			otpRef:'',
			message:''
		}
    }

    componentDidMount(){

	}
	componentWillUnmount(){
    }



  
    

    render(){

		var mobileNoTosendOtp='';
	

         mobileNoTosendOtp=this.props.addsenderRequest.customer.mobile;
        //  var middleStringForOtp='';
		//  	for (let i = 0; i < mobileNoTosendOtp.length; i++) {
		// 		middleStringForOtp=middleStringForOtp+'x';
		// } 

		// mobileNoTosendOtp=mobileNoTosendOtp.substring(0,2)+middleStringForOtp;
		var customerName='';
		var govtIdValue='';
		var customerMobile='';
		var govtIdType='';

		var custoemrVal=this.props.addsenderRequest.customer;
		customerMobile=custoemrVal.mobile;

		customerName=custoemrVal.name;
		
		govtIdType=this.props.addsenderRequest.customer.kyc.type.replace("-"," ");
		govtIdValue=this.props.addsenderRequest.customer.kyc.id;

		// var kycIdlen=govtIdValue.substring(2,govtIdValue.length-2);
	    // var middleString='';
		// for (let i = 0; i < kycIdlen.length; i++) {
		// 	middleString=middleString+'x';
		// } 
		// govtIdValue=govtIdValue.substring(0,2)+middleString+govtIdValue.substring(govtIdValue.length-2,govtIdValue.length-2);
    return(
        
   
		
							<div class="senderdtlcard">
								<div class="row">
							
							
								
							
								<div class="col-12 col-md-4 col-lg-5">
									
									<div class="sender-profile">
									<Avatar name={customerName} round={true} size="44" alt="" />	
										<h4>{customerName!='' && customerName}</h4>
										<p>{customerMobile !='' && customerMobile}</p>
									</div>
									</div>
								

								

									<div class="col-12 col-md-7">
									<div class="sender-profile">
										<h5>{(govtIdType=='AADHAAR_CARD'||govtIdType=='AADHAAR CARD') && 'Aadhaar Card'
										}</h5>
										<h5>{(govtIdType=='BILL_ADDRESS_PROOF'||govtIdType=='BILL ADDRESS PROOF')&&'Voter Card'
										}</h5>
										<h5>{(govtIdType=='DRIVERS_LICENSE'||govtIdType=='DRIVERS LICENSE')&&'Driving License'
										}</h5>
										<h5>{(govtIdType=='PAN_CARD'||govtIdType=='PAN CARD')&&'Pan Card'
										}</h5>
										<h5>{(govtIdType=='PASSPORT')&&'Passport'
										}</h5>
										
										<p>{govtIdValue!='' && govtIdValue}</p>
									</div>
									</div>
									
									
									
									{this.props.senderCustomerId!='' &&
									<div class="col-12"><hr/></div>
									}
                                    
								
									{this.props.senderCustomerId!='' &&
									<div class="col-6 col-md-5">
										<div class="sender-profile">
											<h5>Reference ID</h5>
											<p>{this.props.senderCustomerId}</p>
										</div>
									</div>
									}
									
									{this.props.senderCustomerId!='' &&
									<div class="col-6 col-md-7">
										<div class="sender-profile stxt">
											<h5>Date & Time</h5>
											<p>{moment().format("DD-MM-YYYY HH:mm:ss")}</p>
										</div>
									</div>
									}
									
                                    
	
									
								</div>
							</div>
						
		);
      } 
}

const mapStateToProps = (
	{ errorMessageReduce:{errorMessage,loginErrorMessage},
	miscReduce:{phone,addsenderRequest,addsenderRequestUrl,
	   generateOtpResponse,agentInfo,token,senderCustomerId}}
   ) => ({
	   errorMessage,loginErrorMessage,phone,addsenderRequest,addsenderRequestUrl,
	   generateOtpResponse,agentInfo,token,senderCustomerId
});

export default connect(mapStateToProps, null)(SenderSubDetails);
